// extracted by mini-css-extract-plugin
module.exports = {"toggle-input":"toggle-button_toggle-input__h11ZY","toggle-label":"toggle-button_toggle-label__cGPzd","toggle-dropdown-item":"toggle-button_toggle-dropdown-item__R_J7r"};